// @flow
export { default } from './UserProductsTagView';



// WEBPACK FOOTER //
// ./src/components/user/UserProductsTagView/index.js